// 喊话器
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useRef, useEffect } from 'react'
import { Card, Space, Tooltip, Button, Input, Progress, message, Spin, Slider, theme } from 'antd'
import { ArrowLeftOutlined, LoadingOutlined } from '@ant-design/icons'

import dayjs from 'dayjs'
import './megaphone.css'
import { getAddress, connect, subscribe, publish, disconnect } from './megaphone_mqttService.js';
import AudioRecorder from './AudioRecorder.js';

import { debounce } from '@/common/js/common.js'
import { controllerAPI } from '@/server/commandFlight.js'

import bfz from "@/common/img/airport_surveillance/megaphone/bfz.svg" // 播放
import ztz from "@/common/img/airport_surveillance/megaphone/ztz.svg" // 暂停
import xh_t from "@/common/img/airport_surveillance/megaphone/xh_t.svg" // 循环—开
import xh_f from "@/common/img/airport_surveillance/megaphone/xh_f.svg" // 循环—关
import yl_t from "@/common/img/airport_surveillance/megaphone/yl_t.svg" // 音量—开
import yl_f from "@/common/img/airport_surveillance/megaphone/yl_f.svg" // 音量—关
import dg_t from "@/common/img/airport_surveillance/megaphone/dg_t.svg" // 灯光—开
import dg_f from "@/common/img/airport_surveillance/megaphone/dg_f.svg" // 灯光—关
import bs_t from "@/common/img/airport_surveillance/megaphone/bs_t.svg" // 爆闪—开
import bs_f from "@/common/img/airport_surveillance/megaphone/bs_f.svg" // 爆闪—关

function Megaphone (list) {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const token = localStorage.getItem('dock_token');
  const dockId = list.dockId
  const sn = list.sn
  const { token: { colorBgContainer, colorText }, } = theme.useToken(); //获取主题颜色

  const mqttLinkRef = useRef(false)//mqtt链接成功

  const [loading, setLoading] = useState(false)//加载中···
  const [type, setType] = useState(0)//1:文本喊话 2:文件喊话
  const megaphoneTextRef = useRef('')
  const [megaphoneText, setMegaphoneText] = useState(null)//文本  喊话的文字
  const [megaphoneFile, setMegaphoneFile] = useState(null)//文件 喊话的文字

  const timerRef = useRef(null)//计时器

  const isPlayRef = useRef(false)//是否在播放中
  const [isPlay, setIsPlay] = useState(false)//是否在播放中

  const megaphoneTimeRef = useRef(0)//播放倒计时 时长
  const megaphoneTimeAllRef = useRef(0)//播放总时长

  const sendPlayNumRef = useRef(0)//点击发送播放 的时长
  const sendPlayTimerRef = useRef(null)//点击发送播放 计时器

  const enterNumRef = useRef(0)//进入次数


  const isCycleRef = useRef(false)//是否处于循环播放中

  const isVolumeRef = useRef(false)//音量
  const volumeValueRef = useRef(50)//音量值
  const [volumeValue, setVolumeValue] = useState(50)//音量值

  const isLightingRef = useRef(false)//灯光

  const isStrobeRef = useRef(false)//爆闪

  const PTZPitchAngleRef = useRef(0)//云台俯仰角
  const [PTZPitchAngle, setPTZPitchAngle] = useState(0)//云台俯仰角


  const openOrCloseMqttInfo = async (state) => { //开启或关闭mqtt链接
    let obj = {
      access_token: token,
      dock_id: dockId,
      type: state ? 'enter' : 'exit',
    }
    let res = await controllerAPI(obj)

    if (res.ret !== 200) { message.warning(res.msg); return }
    if (state && res.data) { getMqtt(res.data) }
  }

  const getMqtt = (data) => {//获取mqtt连接
    getAddress(data)
    const onConnect = () => {
      subscribe(`thing/product/${sn}/services`, 1);//发送
      subscribe(`thing/product/${sn}/services_reply`, 1);//获取
      subscribe(`thing/product/${sn}/events`, 0);//获取 播放进度
      mqttLinkRef.current = true
      initializationMegaphone()
    };

    const onMessage = (topic, payload) => {
      let getData = payload ? JSON.parse(payload) : undefined

      if (topic.split('/')[3] === 'services_reply') {
        // console.log('获取到的信息', topic, getData);
      }

      if (topic.split('/')[3] === 'events') {//监听 播放 回调

        if (getData?.data?.output?.progress?.step_key === 'play' && getData?.data?.output?.progress?.percent === 100 && isPlayRef.current === false && enterNumRef.current === 0) {//进入 播放  回调
          if (getData?.method === "speaker_tts_play_start_progress") {//text  播放 回调

            sendPlayNumRef.current = 0
            clearInterval(sendPlayTimerRef.current)
            sendPlayTimerRef.current = null

            enterNumRef.current += 1
            isPlayRef.current = true
            setIsPlay(true)
            setLoading(false)
          } else if (getData?.method === "speaker_audio_play_start_progress") {//file 播放 回调
            sendPlayNumRef.current = 0
            clearInterval(sendPlayTimerRef.current)
            sendPlayTimerRef.current = null


            enterNumRef.current += 1
            isPlayRef.current = true
            setIsPlay(true)
            setLoading(false)
          }
        }
      }
    }

    const onError = (error) => {
      console.error('MQTT error:', error);
      message.warning('喊话器网络欠佳，请重试')
    };

    connect(onConnect, onMessage, onError);
  }

  const getRandomUUID = () => {//随机生成UUID 对应格式的十六进制字符串
    const hexChars = '0123456789abcdef';
    let result = '';
    for (let i = 0; i < 32; i++) {
      result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
    }
    // 格式化为 xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
    return result.slice(0, 8) + '-' +
      result.slice(8, 12) + '-' +
      result.slice(12, 16) + '-' +
      result.slice(16, 20) + '-' +
      result.slice(20);
  }

  const getRandomMD5 = () => { //随机生成md5
    const array = new Uint8Array(32 / 2);
    window.crypto.getRandomValues(array);
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
  }

  const initializationMegaphone = () => { //初始化 喊话器

    sendMQTTInfo(otherInfo(1, 0))//暂停播放
    isPlayRef.current = false
    setIsPlay(false)

    sendMQTTInfo(otherInfo(7, 0))//循环播放——关闭
    isCycleRef.current = false

    sendMQTTInfo(setVolume(50))//将音量大小设置为50
    isVolumeRef.current = false
    volumeValueRef.current = 50
    setVolumeValue(50)

    sendMQTTInfo(otherInfo(9, 0))//灯光—关
    isLightingRef.current = false

    sendMQTTInfo(otherInfo(11, 0))//爆闪—关
    isStrobeRef.current = false

    sendMQTTInfo(otherInfo(18, 0))//关闭云台联动
    sendMQTTInfo(otherInfo(17, 0))//云台角度-0%
    PTZPitchAngleRef.current = 0
    setPTZPitchAngle(PTZPitchAngleRef.current)

    console.log('初始化所有参数');

  }

  const sendMQTTInfo = (obj) => {//发送mqtt信息
    publish(`thing/product/${sn}/services`, JSON.stringify(obj), 0, false)
  }

  const setPlayMode = (type) => { //设置  播放模式
    let code = getRandomUUID()
    let obj = {
      bid: getRandomUUID(),
      data: {
        play_mode: 0,
        psdk_index: 2
      },
      method: "speaker_play_mode_set",
      tid: code,
      timestamp: dayjs().valueOf()
    }
    return obj
  }

  const setVolume = (value) => { //设置  音量大小
    let obj = {
      bid: getRandomUUID(),
      data: {
        play_volume: value,
        psdk_index: 2
      },
      method: "speaker_play_volume_set",
      tid: getRandomUUID(),
      timestamp: dayjs().valueOf()
    }

    return obj
  }

  const setPlayText = (value) => { //设置  播放  文本
    let obj = {
      bid: getRandomUUID(),
      data: {
        psdk_index: 2,
        tts: {
          md5: getRandomMD5(),
          name: getRandomMD5(),
          text: value
        }
      },
      method: "speaker_tts_play_start",
      tid: getRandomUUID(),
      timestamp: dayjs().valueOf()
    }
    return obj
  }

  const setPlayFile = (url) => { //设置  播放  文件
    let obj = {
      bid: getRandomUUID(),
      data: {
        file: {
          format: "pcm",
          md5: getRandomMD5(),
          name: "播放文件",
          url: url
        },
        psdk_index: 2
      },
      method: "speaker_audio_play_start",
      tid: getRandomUUID(),
      timestamp: dayjs().valueOf()
    }
    return obj
  }

  const otherInfo = (index, value) => { //设置其他信息
    let obj = {
      bid: getRandomUUID(),
      data: {
        index: index,
        psdk_index: 2,
        value: value
      },
      method: "psdk_widget_value_set",
      tid: getRandomUUID(),
      timestamp: dayjs().valueOf()
    }
    return obj
  }

  const AudioBack = (obj) => { //喊话器回调
    if (obj.url) {
      sendMQTTInfo(otherInfo(1, 0))//暂停播放
      isPlayRef.current = false
      setIsPlay(false)
      megaphoneTimeAllRef.current = Number(localStorage.getItem('megaphoneTime'))
      setMegaphoneFile(obj.url)
    }
  }

  const countNumber = () => { //计算倒计时
    megaphoneTimeRef.current = 0
    if (isPlayRef.current) {
      timerRef.current = setInterval(() => {
        megaphoneTimeRef.current += 1
        if ((megaphoneTimeAllRef.current - megaphoneTimeRef.current) === -1) { //播放完毕
          if (isCycleRef.current) {
            clearInterval(timerRef.current)
            timerRef.current = null
            countNumber()
          } else {
            setIsPlay(false)
            isPlayRef.current = false
            setLoading(false)
          }
        }
      }, 1000);
    } else {
      if (timerRef.current) {
        clearInterval(timerRef.current)
        timerRef.current = null
      }
    }
  }


  useEffect(() => {
    openOrCloseMqttInfo(true)

    return () => {
      if (mqttLinkRef.current) {//销毁 mqtt
        console.log('销毁mqtt')
        disconnect()
        openOrCloseMqttInfo(false)
        mqttLinkRef.current = false
      }

      if (timerRef.current) {//销毁计时器
        clearInterval(timerRef.current)
        timerRef.current = null
      }

    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    countNumber()
    // eslint-disable-next-line
  }, [isPlay])

  useEffect(() => {
    setLoading(false)
    setTimeout(() => {
      if (mqttLinkRef.current) {
        switch (list.type) {
          case 0:
            if (mqttLinkRef.current) {//销毁 mqtt
              disconnect()
              openOrCloseMqttInfo(false)
              mqttLinkRef.current = false
            }

            if (timerRef.current) {//销毁计时器
              clearInterval(timerRef.current)
              timerRef.current = null
            }
            break;
          case 1:
            setMegaphoneText(null)
            sendMQTTInfo(setPlayMode(1))
            break;

          case 2:
            setMegaphoneFile(null)
            sendMQTTInfo(setPlayMode(2))
            break;

          default:
            break;
        }
        setType(list.type)
      }
    }, 1000);



    // eslint-disable-next-line
  }, [list.type])

  return (
    <Card className='pos_rel' style={{ border: 0 }} styles={{ body: { padding: 16, width: 400 } }}>

      {
        type > 0
          ? (
            <>
              <div className='flex jcsb align_center'>
                <>{/* 主控 */}
                  <div className='flex_col jcc wid100 marR24'>
                    <>{/* 操控 */}
                      <div className='flex jcsb align_center'>
                        <>{/* 控制条 */}
                          <Space size='small'>
                            <>{/* 播放 */}
                              <Tooltip title='播放'>
                                {
                                  isPlayRef.current
                                    ? (
                                      <img
                                        className='pointer'
                                        src={bfz}
                                        alt='播放中(点击=》暂停播放)'
                                        onClick={() => {
                                          isPlayRef.current = false
                                          setIsPlay(false)
                                          sendMQTTInfo(otherInfo(1, 0))//暂停播放
                                          setLoading(false)
                                        }}
                                      />
                                    )
                                    : (
                                      <img
                                        className={`pointer ${megaphoneTimeAllRef.current ? '' : 'opa25'}`}
                                        src={ztz}
                                        alt='暂停中(点击=》开始播放)'
                                        onClick={() => {
                                          if (megaphoneTimeAllRef.current) {
                                            sendPlayTimerRef.current = setInterval(() => {
                                              sendPlayNumRef.current += 1
                                              if (sendPlayNumRef.current > 20) {
                                                message.warning('网络延迟，请重新上传')
                                                setIsPlay(false)
                                                setLoading(false)
                                                clearInterval(sendPlayTimerRef.current)
                                                sendPlayTimerRef.current = null
                                              }
                                            }, 1000);
                                            enterNumRef.current = 0
                                            setLoading(true)
                                            // sendMQTTInfo(otherInfo(1, 1))//开始播放
                                            setTimeout(() => {
                                              if (type === 1) { sendMQTTInfo(setPlayText(megaphoneText)) }
                                              if (type === 2) { sendMQTTInfo(setPlayFile(megaphoneFile)) }
                                            }, 500);
                                          }
                                        }}
                                      />
                                    )
                                }
                              </Tooltip>
                            </>

                            <>{/* 循环 */}
                              <Tooltip title='循环'>
                                {
                                  isCycleRef.current
                                    ? (
                                      <img
                                        className='pointer'
                                        src={xh_t}
                                        alt='循环—开'
                                        onClick={() => {
                                          isCycleRef.current = !isCycleRef.current
                                          sendMQTTInfo(otherInfo(7, 0))
                                        }}
                                      />
                                    )
                                    : (
                                      <img
                                        className='pointer'
                                        src={xh_f}
                                        alt='循环—关'
                                        onClick={() => {
                                          isCycleRef.current = !isCycleRef.current
                                          sendMQTTInfo(otherInfo(7, 1))
                                        }}
                                      />
                                    )
                                }
                              </Tooltip>
                            </>

                            <>{/* 音量 */}
                              <div className='pos_rel'>
                                <Tooltip title='音量'>
                                  {
                                    volumeValueRef.current !== 0
                                      ? (
                                        <img
                                          className='pointer'
                                          src={yl_t}
                                          alt='音量—开'
                                          onClick={() => { isVolumeRef.current = !isVolumeRef.current }}
                                        />
                                      )
                                      : (
                                        <img
                                          className='pointer'
                                          src={yl_f}
                                          alt='音量—关'
                                          onClick={() => { isVolumeRef.current = !isVolumeRef.current }}
                                        />
                                      )
                                  }
                                </Tooltip>


                                <>{/* 音量控制 */}
                                  <div
                                    className='pos_abs flex jcc align_center h120 radius8 pdTB8 pdRL10'
                                    style={{ backgroundColor: '#141414', top: -144, left: -15, display: isVolumeRef.current ? `` : `none` }}
                                  >
                                    <Slider
                                      className='h88'
                                      vertical
                                      step={10}
                                      value={volumeValue}
                                      onChange={(e) => {
                                        volumeValueRef.current = e
                                        setVolumeValue(e)
                                        sendMQTTInfo(setVolume(e))
                                      }}
                                    />
                                  </div>
                                </>
                              </div>
                            </>

                            <>{/* 灯光 */}
                              <Tooltip title='灯光'>
                                {
                                  isLightingRef.current
                                    ? (
                                      <img
                                        className='pointer'
                                        src={dg_t}
                                        alt='灯光—开'
                                        onClick={() => {
                                          isLightingRef.current = !isLightingRef.current
                                          sendMQTTInfo(otherInfo(9, 0))
                                        }}
                                      />
                                    )
                                    : (
                                      <img
                                        className='pointer'
                                        src={dg_f}
                                        alt='灯光—关'
                                        onClick={() => {
                                          isLightingRef.current = !isLightingRef.current
                                          isStrobeRef.current = false
                                          sendMQTTInfo(otherInfo(9, 1))
                                        }}
                                      />
                                    )
                                }
                              </Tooltip>
                            </>

                            <>{/* 爆闪 */}
                              <Tooltip title='爆闪'>
                                {
                                  isStrobeRef.current
                                    ? (
                                      <img
                                        className='pointer'
                                        src={bs_t}
                                        alt='爆闪—开'
                                        onClick={() => {
                                          isStrobeRef.current = !isStrobeRef.current
                                          sendMQTTInfo(otherInfo(11, 0))
                                        }}
                                      />
                                    )
                                    : (
                                      <img
                                        className='pointer'
                                        src={bs_f}
                                        alt='爆闪—关'
                                        onClick={() => {
                                          isStrobeRef.current = !isStrobeRef.current
                                          isLightingRef.current = false
                                          sendMQTTInfo(otherInfo(11, 1))
                                        }}
                                      />
                                    )
                                }
                              </Tooltip>
                            </>
                          </Space>
                        </>

                        <>{/* 时间 */}
                          <span className='opa25'>
                            {megaphoneTimeAllRef.current
                              ? (megaphoneTimeAllRef.current - megaphoneTimeRef.current) > 9
                                ? (`- 0:${megaphoneTimeAllRef.current - megaphoneTimeRef.current}`)
                                : (`- 0:0${megaphoneTimeAllRef.current - megaphoneTimeRef.current}`)
                              : '--:--'
                            }
                          </span>
                        </>
                      </div>
                    </>

                    <>{/* 进度条 */}
                      <Progress
                        status="active"
                        showInfo={false}
                        strokeColor='#FFF'
                        className='marTB8'
                        percent={(megaphoneTimeRef.current / megaphoneTimeAllRef.current) * 100}
                      />
                    </>

                    <>{/* 喊话器 编辑 */}
                      {
                        type === 1 &&
                        <>{/* 文本 */}
                          <div className='flex jcsb'>
                            <Input
                              className='marR8'
                              disabled={isPlayRef.current}
                              showCount
                              maxLength={30}
                              placeholder="输入所需喊话内容"
                              onChange={(e) => {
                                megaphoneTextRef.current = e.target.value
                                setMegaphoneText(e.target.value)
                              }}
                            />

                            <Button
                              type='primary'
                              disabled={!megaphoneText || isPlayRef.current || loading}
                              onClick={() => {
                                isPlayRef.current = false
                                setLoading(true)
                                sendMQTTInfo(otherInfo(1, 0))//暂停播放
                                setTimeout(() => {
                                  megaphoneTimeAllRef.current = Math.floor(megaphoneTextRef.current.length * 0.5)
                                  setLoading(false)
                                }, 1000);
                              }}
                            >
                              {
                                isPlayRef.current || loading
                                  ? <LoadingOutlined />
                                  : megaphoneText
                                    ? '发送'
                                    : '请输入文本'
                              }
                            </Button>
                          </div>
                        </>
                      }

                      {
                        type === 2 &&
                        <>{/* 文字 */}
                          <div className='h34'>
                            <AudioRecorder isLoading={type === 2 && loading ? true : false} returnBack={AudioBack} />
                          </div>
                        </>
                      }
                    </>
                  </div>
                </>

                <>{/* 云台  俯仰 */}
                  <Slider
                    className='h60'
                    // styles={{}}
                    vertical
                    step={10}
                    value={PTZPitchAngle}
                    onChange={(e) => {
                      PTZPitchAngleRef.current = e
                      setPTZPitchAngle(e)
                      sendMQTTInfo(otherInfo(17, e))
                    }}
                  />
                </>
              </div>
            </>
          )
          : (
            <div className=' hei100 wid100 flex jcsb align_center'>
              <Spin />
            </div>
          )
      }




    </Card >
  )
}
export default Megaphone;